import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-upload"
}, null, -1);

const _hoisted_3 = {
  class: "el-upload__text"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 ");

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, "点击下面附件进行下载", -1);

const _hoisted_6 = {
  key: 1
};
import { useI18n } from 'vue-i18n';
import request from '@/api/request.js';
import { reactive, getCurrentInstance, ref } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { elMessage } from '@/utils';
export default {
  __name: 'upload',
  props: {
    type: {
      type: Number,
      default: 2
    },
    fileList: {
      type: Array,
      default: () => []
    },
    uploadData: {
      type: Object
    },
    // 上傳時附帶的參數
    action: {
      type: String
    },
    //action请求地址
    isDisable: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: 'file'
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isAutoUpload: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    isShowFile: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: "text"
    },
    accept: {
      type: String,
      default: ""
    },
    uploadText: {
      type: String,
      default: "点击上传"
    }
  },
  emits: ['update:modelValue', 'onChange', 'handleSuccess'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n(); // const { emit } = getCurrentInstance()

    watch(() => props.fileList, newVal => {
      console.log('props.fileList', newVal);
    }, {
      deep: true
    });

    const UploadFile = param => {
      console.log('112', param);
      const formData = new FormData();
      formData.append(props.fileName, param.file);

      if (props.uploadData) {
        for (let key in props.uploadData) {
          formData.append(key, props.uploadData[key]);
        }
      } // axios({
      //   method: 'POST',
      //   url: props.action,
      //   headers: { 'Content-Type': 'multipart/form-data'},
      //   data: formData
      // }).then(res => {
      //   console.log(res)
      // })


      console.log('action', props.action);
      request.post(props.action, formData, {
        type: 'upload'
      }).then(res => {
        if (res.code == 0) {
          ElMessage({
            message: '上传成功!',
            type: 'success'
          });
          handleSuccess();
        } else {
          ElMessage({
            message: res.msg,
            type: 'error'
          });
        }
      });
    };

    const handleSuccess = data => {
      emit("handleSuccess", data);
    };

    const handlePreview = () => {};

    const handleRemove = () => {};

    const beforeRemove = () => {};

    const handleExceed = (files, fileList) => {
      ElMessage.warning(elMessage('warning', t('当前限制选择1个文件,请删除后再重新上传', {
        num: props.limit
      }), false));
    };

    const uploadREF = ref(null); // 暴露属性给父组件

    expose({
      uploadREF
    });

    const fileChange = (file, fileList) => {
      console.log('fileChange', file, fileList);
      if (file.status !== 'ready') return false;
      /**
       * 1. 清除文件对象
       * 2. 取出上传文件的对象,在其它地方也可以使用
       * 3. 重新手动赋值filstList,免得自定义上传成功了,而fileList并没有动态改变,这样每次都是上传一个对象
       * */

      if (!props.isMultiple) {
        emit("update:fileList", fileList);
      } else {
        props.fileList.push(file);
      }

      emit("onChange", file); // uploadREF.value.clearFiles();
    };

    const fileRemove = (file, fileList) => {
      console.log(file, fileList);
      emit("update:fileList", fileList);
    }; // 上傳文件


    const onBeforeUploadImage = file => {
      return true; // const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png'
      // const isLt1M = file.size / 1024 / 1024 < 1
      // if (!isIMAGE) {
      //   this.$message.error('上传文件只能是图片格式!')
      // }
      // if (!isLt1M) {
      //   this.$message.error('上传文件大小不能超过 1MB!')
      // }
      // return isIMAGE && isLt1M
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_upload, {
        drag: __props.type == '1',
        ref_key: "uploadREF",
        ref: uploadREF,
        action: "#",
        multiple: __props.isMultiple || false,
        class: "upload-demo",
        "on-change": fileChange,
        "show-file-list": __props.isShowFile,
        "on-preview": handlePreview,
        "on-remove": fileRemove,
        "list-type": __props.listType || 'text',
        "file-list": __props.fileList,
        "on-success": handleSuccess,
        "before-upload": onBeforeUploadImage,
        "auto-upload": __props.isAutoUpload || false,
        limit: __props.limit || 1,
        "on-exceed": handleExceed,
        accept: __props.accept
      }, {
        tip: _withCtx(() => [_renderSlot(_ctx.$slots, "tip")]),
        default: _withCtx(() => [__props.type == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("em", null, _toDisplayString(_ctx.$t('点击上传')), 1)]), _hoisted_5])) : _createCommentVNode("", true), __props.type == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "uploadSolt"), __props.isShowBtn ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "cms-op-btn cms-op-btn-main",
          disabled: __props.isDisable
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(__props.uploadText)), 1)]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["drag", "multiple", "show-file-list", "list-type", "file-list", "auto-upload", "limit", "accept"])]);
    };
  }

};